const labels = {
    valetParking: ['valetParking', 'label.park.valet', 'valet-parking', '#727272'],
    accessibilityForDisabled: ['accessibilityForDisabled', 'label.park.accessibility', 'handycap', '#009baa'],
    toilets: ['toilets', 'label.park.toilets', 'toilets', '#82be64'],
    jumpStartBattery: ['jumpStartBattery', 'label.park.jumpstart', 'jump-start-battery', '#2896d7'],
    electricCharging: ['electricCharging', 'label.park.electricCharging', 'electric-charging', '#2896d7'],
    electricPlugin: ['electricPlugin', 'label.park.electricPlugin', 'electric-plugin', '#82be64'],
    carService: ['carService', 'label.park.carService', 'car-service', '#dc3773'],
    carWash: ['carWash', 'label.park.carWash', 'car-wash', '#7d5aa5'],
    tyreInflation: ['tyreInflation', 'label.park.tyreInflation', 'tyre-inflation', '#727272'],
    carRental: ['carRental', 'label.park.carRental', 'car', '#82BE64'],
    bicycleCharge: ['bicycleCharge', 'label.park.bicycleCharge', 'bicycle-charge', '#727272'],
    bicycleRental: ['bicycleRental', 'label.park.bicycleRental', 'bicycle', '#f5a028'],
    parentAndChild: ['parentAndChild', 'label.park.parentAndChild', 'parent-child', '#f5a028'],
    umbrella: ['umbrella', 'label.park.umbrella', 'umbrella', '#7d5aa5'],
    paymentMobile: ['paymentMobile', 'label.park.paymentMobile', 'payment-mobile', '#dc3773'],
    nfc: ['nfc', 'label.park.nfc', 'nfc', '#7d5aa5'],
    motorbike: ['motorbike', 'label.park.motorbike', 'motorbike', '#727272'],
    byBus: ['byBus', 'label.park.access.by.bus', 'by-bus'],
    byCar: ['byCar', 'label.park.access.by.car', 'by-car'],
    byPublicTransport: ['byPublicTransport', 'label.park.access.transport', 'public-transport'],
    onFoot: ['onFoot', 'label.park.access.on.foot', 'on-foot'],
    shuttle: ['shuttle', 'label.park.access.shuttle', 'by-bus'],
    what3Words: ['what3Words', 'label.park.3words', 'what-3-words', '#00aeef', 'https://what3words.com/'],
}

const getServiceIcons = (services = {}, limit) =>
    Object.keys(services)
        .map(key => (services[key] && labels[key][1] !== '' ? labels[key] : false))
        .filter(Boolean)
        .slice(0, limit)

const ServiceIcons = ({ services = {}, render, limit }) => {
    const icons = getServiceIcons(services, limit)
    return icons.map(([key, title, type, color, linkPrefix], index) =>
        render({ type, title, index, color, key, linkPrefix })
    )
}

export default ServiceIcons
